module.exports = __webpack_public_path__ + "img/coupons@3x.9124b6f.png";